import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFilledUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 10,
	viewBox: "0 0 16 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.23637 10H8.35603L14.7672 10C15.8643 10 16.4128 8.48217 15.6357 7.5924L9.71596 0.814524C8.76744 -0.271507 7.22466 -0.271507 6.27613 0.814524L4.02481 3.39221L0.356417 7.5924C-0.40926 8.48217 0.139285 10 1.23637 10Z",
		fill: "currentColor"
	})
});
export default SvgArrowFilledUp;
